import { render, staticRenderFns } from "./freeWorld.vue?vue&type=template&id=5537b51a&"
import script from "./freeWorld.vue?vue&type=script&lang=js&"
export * from "./freeWorld.vue?vue&type=script&lang=js&"
import style0 from "./freeWorld.vue?vue&type=style&index=0&id=5537b51a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports